import * as React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Paper,
  Grid,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchRegisteredUsers } from "../../../../Reducer/adminSlice";
import UserDetailsForm from "./UserDetailsForm"; // Correct way
import ProductSelection from "./ProductSelection.jsx";
import CustomListOptions from "./CustomListOptions.jsx";

export default function EditDialog({ open, handleClose, user, existingSubscribeProduct }) {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.registerUser);

  const [selectedProducts, setSelectedProducts] = React.useState(user?.products || []);
  const [loading, setLoading] = React.useState(false);
  const [customFieldDescription, setCustomFieldDescription] = React.useState({});
 
  console.log("existingSubscribeProduct from edit dialog", existingSubscribeProduct);
  
  const [formData, setFormData] = React.useState({
    username: user?.username || "",
    role: user?.role || "user",
    amount: existingSubscribeProduct?.amount_paid || "",
    orderDate: existingSubscribeProduct?.order_date?.split("T")[0] || "",
    exhibitors_count: existingSubscribeProduct?.exhibitors_count || "",
    user_id: user?.id || "",
    custom_list: existingSubscribeProduct?.custom_list?.[0] || {
      country: false,
      industry: false,
      person_location: false,
      generic_email: false,
      company_phone: false,
      direct_dial: false,
    
      company_name: true,
      website: true,
      description: true,
      employee_count: true,
      address: true,
      booth_number: true,
      first_name: true,
      last_name: true, 
      title: true,
      email: true,
      linkedin_url: true,
      source_url: true,
      leads_comment: true,
      company_comment: true    
    },
  
    custom_field_description: existingSubscribeProduct?.custom_list?.[0].descriptions || [],
  });

  React.useEffect(() => {
    if (open) {
      setSelectedProducts(user?.products || []);
      setFormData((prev) => ({
        ...prev,
        amount: existingSubscribeProduct?.amount_paid || "",
        orderDate: existingSubscribeProduct?.order_date?.split("T")[0] || "",
        exhibitors_count: existingSubscribeProduct?.exhibitors_count || "",
        custom_list: existingSubscribeProduct?.custom_list?.[0] || prev.custom_list,
      }));
    }
  }, [open, existingSubscribeProduct, user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const updatedData = {
      ...formData,
      product_ids: selectedProducts,
      subscribe_product_id: existingSubscribeProduct?.id,
    };

    try {
      const apiUrl = existingSubscribeProduct
        ? "/api/v1/update-assign-product"
        : "/api/v1/assign-product";

      await axios.post(apiUrl, updatedData);

      toast.success(existingSubscribeProduct ? "User details updated successfully!" : "Product assigned successfully!");
      dispatch(fetchRegisteredUsers({ page: 1, limit: 10, ...filters }));
      handleClose();
    } catch (error) {
      toast.error("Failed to process user details!");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        component: "form",
        onSubmit: handleSubmit,
        sx: { 
          p: 3, 
          borderRadius: 4,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
          background: 'linear-gradient(to bottom right, #f9f9f9, #ffffff)'
        },
      }}
    >
      <DialogTitle sx={{ 
        textAlign: "center", 
        fontWeight: "bold", 
        mb: 1,
        fontSize: '1.5rem',
        color: 'primary.main',
        py: 2,
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      }}>
        Edit User Details
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ 
          textAlign: "center", 
          mb: 3, 
          color: "text.secondary",
          fontStyle: 'italic'
        }}>
          Edit the details and save your changes
        </DialogContentText>

        {/* First Row: User Details & Product Selection */}
        <Grid container spacing={3}>
          {/* Left: User Details */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} sx={{ 
              p: 3, 
              borderRadius: 3, 
              height: "100%",
              borderLeft: '4px solid',
              borderColor: 'primary.main',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.1)'
              }
            }}>
              <UserDetailsForm formData={formData} setFormData={setFormData} />
            </Paper>
          </Grid>

          {/* Right: Product Selection */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} sx={{ 
              p: 3, 
              borderRadius: 3, 
              height: "100%",
              borderLeft: '4px solid',
              borderColor: 'secondary.main',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.1)'
              }
            }}>
              <ProductSelection 
                selectedProducts={selectedProducts} 
                setSelectedProducts={setSelectedProducts} 
                existingSubscribeProduct={existingSubscribeProduct} 
              />
            </Paper>
          </Grid>

          {/* Second Row: Custom List Options (Full Width) */}
          <Grid item xs={12}>
            <Paper elevation={4} sx={{ 
              p: 3, 
              borderRadius: 3,
              mt: 1,
              background: 'rgba(245, 245, 245, 0.5)',
              borderTop: '1px solid rgba(0, 0, 0, 0.08)'
            }}>
              <CustomListOptions 
                formData={formData} 
                setFormData={setFormData} 
                customFieldDescription={customFieldDescription} 
                setCustomFieldDescription={setCustomFieldDescription} 
              />
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ 
        justifyContent: "space-between", 
        px: 3, 
        pb: 3,
        pt: 2,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)'
      }}>
        <Button 
          onClick={handleClose} 
          disabled={loading} 
          sx={{ 
            color: "text.secondary",
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          type="submit" 
          variant="contained" 
          color="primary" 
          disabled={loading}
          sx={{
            px: 4,
            py: 1,
            borderRadius: 2,
            fontWeight: 'bold',
            boxShadow: '0px 2px 10px rgba(25, 118, 210, 0.3)',
            '&:hover': {
              boxShadow: '0px 4px 12px rgba(25, 118, 210, 0.4)'
            }
          }}
        >
          {loading ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}